import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=2c5555c2&scoped=true&"
var script = {}
import style0 from "./terms.vue?vue&type=style&index=0&id=2c5555c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5555c2",
  null
  
)

/* custom blocks */
import block0 from "./terms.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports